import { render, staticRenderFns } from "./ComplaintsReport.vue?vue&type=template&id=6ce46426&lang=pug"
import script from "./ComplaintsReport.vue?vue&type=script&lang=js"
export * from "./ComplaintsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports